import { Capacitor } from '@capacitor/core'
import { createTheme } from '@mui/system'

const mobileTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0, // Start at 0
      sm: 600, // Everything maps to "sm"
      md: 90000, // Unreachable
      lg: 90000, // Unreachable
      xl: 90000, // Unreachable
    },
  },
})

const desktopTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
})

const mdp = {
  values: {
    xs: 0, // Start at 0
    sm: 600, // Everything maps to "sm"
    md: 90000, // Unreachable
    lg: 90000, // Unreachable
    xl: 90000, // Unreachable
  },
}
const dbp = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
}
export const breakpoints = Capacitor.isNativePlatform() ? mobileTheme : desktopTheme
export const breakpoints_raw = Capacitor.isNativePlatform() ? mdp : dbp
